import { createFileRoute } from "@tanstack/react-router";

import { ResetPasswordPage } from "~/features/auth/pages/reset-password";

export const Route = createFileRoute("/(auth)/_auth/reset-password")({
  component: () => <ResetPasswordPage />,
  errorComponent: ({ error }: { error: Error }) => (
    <div role="alert" className="flex min-h-screen w-full items-center justify-center p-4">
      <div className="text-center">
        <h1 className="text-2xl font-bold">Reset password Error</h1>
        <pre className="mt-4">{error.message}</pre>
      </div>
    </div>
  ),
});
